import type { CampaignEdmEntityResourceIdentifiers } from '@bingads-webui/campaign-odata-schemas/types/edm.d';
import { edmCampaign } from './edm-campaign';

export interface EdmScopeLike {
  values: {
    cid?: string | number;
    aid?: string | number;
    campaignId?: string | number;
    adGroupId?: string | number;
  };
  acid?: string | number;
}

export interface EntityFromScopeResult {
  currentCustomer: CampaignEdmEntityResourceIdentifiers.Customer | null;
  currentAccount: CampaignEdmEntityResourceIdentifiers.Account | null;
  currentCampaign: CampaignEdmEntityResourceIdentifiers.Campaign | null;
  currentAdGroup: CampaignEdmEntityResourceIdentifiers.AdGroup | null;
  currentEntity:
    | CampaignEdmEntityResourceIdentifiers.Customer
    | CampaignEdmEntityResourceIdentifiers.Account
    | CampaignEdmEntityResourceIdentifiers.Campaign
    | CampaignEdmEntityResourceIdentifiers.AdGroup
    | null;
}

/**
 * get edm entity references from scope info
 * @param {Object} scope the scope from ScopeContext in @bingads-webui-react/scope-service
 * @returns {object} object containing entity references of current scope
 */
export function getEntityFromScope(scope: EdmScopeLike): EntityFromScopeResult {
  const {
    values: {
      cid, aid, adGroupId, campaignId,
    },
    acid,
  } = scope;

  let currentCustomer: CampaignEdmEntityResourceIdentifiers.Customer | null = null;
  let currentAdvertiserCustomer: CampaignEdmEntityResourceIdentifiers.Customer | null = null;
  let currentAccount: CampaignEdmEntityResourceIdentifiers.Account | null = null;
  let currentCampaign: CampaignEdmEntityResourceIdentifiers.Campaign | null = null;
  let currentAdGroup: CampaignEdmEntityResourceIdentifiers.AdGroup | null = null;
  let currentEntity: EntityFromScopeResult['currentEntity'] = null;

  if (cid) {
    currentCustomer = edmCampaign.Customers.$withKey(cid);
    currentAdvertiserCustomer = acid ? edmCampaign.Customers.$withKey(acid) : null;
    currentEntity = currentCustomer;
    if (aid) {
      currentAccount = (currentAdvertiserCustomer || currentCustomer).Accounts.$withKey(aid);
      currentEntity = currentAccount;
      if (campaignId) {
        currentCampaign = currentAccount.Campaigns.$withKey(campaignId);
        currentEntity = currentCampaign;
        if (adGroupId) {
          currentAdGroup = currentCampaign.AdGroups.$withKey(adGroupId);
          currentEntity = currentAdGroup;
        }
      }
    }
  }

  return {
    currentCustomer,
    currentAccount,
    currentCampaign,
    currentAdGroup,
    currentEntity,
  };
}
